// extracted by mini-css-extract-plugin
module.exports = {"errorPageHolder":"TimeoutErrorPage_errorPageHolder__2gjCq","showboatLogo":"TimeoutErrorPage_showboatLogo__3fOcU"};